const Notification = () => import('@/modules/notification');
import checkPermissions from './checkPermissions';

export default [
  {
    path: '/notificacoes/criar/:formType',
    name: 'create-notification',
    component: Notification,
    beforeEnter: (to, from, next, ) => checkPermissions(next, 'CREATE_NOTIFICATION',),    
  },
  {
    path: '/notificacoes/editar/:id',
    name: 'edit-notification',
    component: Notification,
    // beforeEnter: (to, from, next ) => checkPermissions(next, 'UPDATE_NOTIFICATION'),    
  },  
];
